import { get, post } from ".";

// reports table
export const getReportsTableApi = async (projectId, reportType) => {
  return await get(`project/${projectId}/reports?reportType=${reportType}`);
};

// latest report details
export const getLatestReportsDetailsApi = async (projectId, reportId) => {
  return await get(`project/${projectId}/reports/extract_latest_report?reportId=${reportId}`);
};

// save edit/complete button
export const saveEditApi = async (projectId, reportType, reportId, prepareBy, action, params) => {
  return await post(`project/${projectId}/reports/save_report?reportType=${reportType}&reportId=${reportId}&prepareBy=${prepareBy}&action=${action}`, params);
};

// submit button
export const submitReportApi = async (projectId, reportType, reportId, params) => {
  return await post(`project/${projectId}/reports/generate_report?reportType=${reportType}&reportId=${reportId}`, params);
};

// reject or retract button
export const updateReportStatusApi = async (projectId, reportType, action, reportId, rejectionReason) => {
  return await post(`project/${projectId}/reports/update-report-status?reportType=${reportType}&action=${action}&reportId=${reportId}&rejectionReason=${rejectionReason}`);
};

// upload photo from local
export const uploadLocalImageApi = async (projectId, reportId, params) => {
  return await post(`project/${projectId}/reports/upload-report-image?reportId=${reportId}`, params);
};

//ger all report images
export const getReportImagesApi = async (projectId, reportId) => {
  return await get(`project/${projectId}/reports/report-images?reportId=${reportId}`);
};

//get reject history
export const getRejectHistoryApi = async (projectId, reportId) => {
  return await get(`project/${projectId}/reports/reject-history?reportId=${reportId}`);
};

//upload appendix pdf
export const uploadAppendixPDFApi = async (projectId, reportId, params) => {
  return await post(`project/${projectId}/reports/upload-report-appendix?reportId=${reportId}`, params);
};

//get all appendix pdfs
export const getReportAppendixPDFApi = async (projectId, reportId) => {
  return await get(`project/${projectId}/reports/report-appendix-files?reportId=${reportId}`);
};

export const isReportLockedApi = async (projectId, reportId) => {
  return await get(`project/${projectId}/reports/is-report-locked?reportId=${reportId}`);
};

export const lockReportApi = async (projectId, reportId) => {
  return await post(`project/${projectId}/reports/lock-report?reportId=${reportId}`);
};

export const unlockReportApi = async (projectId, reportId) => {
  return await post(`project/${projectId}/reports/unlock-report?reportId=${reportId}`);
};